export const getSafeRootDomain = (): string | undefined => {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return undefined;
  }

  const { hostname } = window.location;
  return hostname?.split('.').slice(-2).join('.');
};

export const getQueryParamsFromUrl = (url: string) => {
  const pairs = url.split('?')?.[1]?.split('&') || [];

  return pairs.reduce<Record<string, unknown>>((result, pair) => {
    const [key, value] = pair.split('=');

    return {
      ...result,
      [decodeURIComponent(key)]: decodeURIComponent(value),
    };
  }, {});
};

export const getSafeQueryParams = () => {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return undefined;
  }

  return getQueryParamsFromUrl(window.location.href);
};

export const getPathname = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  return window?.location?.pathname;
};
